import React, { useEffect, useState } from "react";
import {
  getFieldsOfStudies,
  getFieldsOfStudyCategories,
  getFieldsOfStudy,
  setFieldsOfStudy,
  deleteFieldsOfStudy,
} from "../../services/dictionary";
import Lists from "../../modules/hcmd/components/Lists";
import { useParams } from "react-router-dom";
import Forms from "../../modules/hcmd/components/Forms";
import { usePermission } from "../../services/auth";

FieldsOfStudies.propTypes = {};

function FieldsOfStudies(props) {
  let { id } = props;

  const [isForm, setIsForm] = useState(false);

  const permissions = usePermission("dictionary");
  const params = useParams();
  if (!id && !isNaN(parseInt(params.id)) && parseInt(params.id) >= 0) {
    id = parseInt(params.id);
    if (!isForm) {
      setIsForm(true);
    }
  } else if (!isNaN(parseInt(id)) && parseInt(id) >= 0 && !isForm) {
    setIsForm(true);
  } else if (isForm) {
    setIsForm(false);
  }

  // ide jonnek a tipusnal hasznalt egyeb adatok deklaralasa
  const [fieldsOfStudyCategories, setFieldsOfStudyCategories] = useState([]);
  useEffect(() => {
    getFieldsOfStudyCategories()
      .then((response) => {
        setFieldsOfStudyCategories(response.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  // ide jon az oszlopok deklaralasa
  const columns = [
    {
      field: "id",
      fieldType: "number",
      hide: true,
    },
    {
      field: "name",
      fieldType: "text",
      headerName: "Megnevezés",
      validation: {
        required: true,
        minLength: 3,
      },
    },
    {
      field: "fieldsOfStudyCategoryId",
      fieldType: "select",
      headerName: "Tanulmányterület",
      validation: {
        required: true,
      },
      valueGetter: (params) => {
        const fieldsOfStudyCategory = fieldsOfStudyCategories.find(
          (item) => item.id === params.row.fieldsOfStudyCategoryId
        );
        return fieldsOfStudyCategory
          ? fieldsOfStudyCategory.name
          : `ismeretlen ${params.row.fieldsOfStudyCategoryId}`;
      },
    },
    {
      field: "priority",
      fieldType: "number",
      // editable: false,
      defaultValue: 1,
      headerName: "Prioritás",
      width: 100,
    },
    {
      field: "isActive",
      fieldType: "boolean",
      defaultValue: true,
      headerName: "Státusz",
      width: 100,
      valueGetter: (params) => {
        return params.row.isActive ? "aktív" : "inaktív";
      },
    },
  ];

  // ide jon a fejlec deklaralasa
  const header = {
    title: "Foglalkozások",
    url: "/dictionary/fields-of-studies",
    item: "foglalkozás",
  };

  return (
    <>
      {isForm && (
        <Forms
          editable={true}
          id={id}
          header={header}
          permissions={permissions}
          columns={columns}
          getFunc={getFieldsOfStudy}
          setFunc={setFieldsOfStudy}
          fieldsOfStudyCategories={fieldsOfStudyCategories}
        ></Forms>
      )}
      {!isForm && (
        <Lists
          header={header}
          permissions={permissions}
          getFunc={getFieldsOfStudies}
          isDictionary={true}
          deleteFunc={deleteFieldsOfStudy}
          columns={columns}
          fieldsOfStudyCategories={fieldsOfStudyCategories}
        ></Lists>
      )}
    </>
  );
}

export default FieldsOfStudies;
